import * as zod from 'zod';

export const ActuateVacuumVariables = zod.object({});

export type ActuateVacuumVariables = zod.infer<typeof ActuateVacuumVariables>;
